<ng-container *ngIf="(marketTime$ | async) as marketTime">
  <prlw-market-time-component
    [marketTime]="marketTime"
    [xsmall]="xsmall$ | async"
    [prlwTradingTooltip]="tooltipText"
  ></prlw-market-time-component>
</ng-container>
